import Laser from "../../model/skillTree/laser/Laser";
import GervaisAnimatedSpritesheet from "../../model/sprite/GervaisAnimatedSpritesheet";
import { GervaisSpriteNames } from "../../model/sprite/GervaisSpriteNames";
import { Settings } from "../../Settings";
import SkillRenderer from "./SkillRenderer";

export default class LaserSkillRenderer extends SkillRenderer {
    /**
     * @param {Laser[]} laserArray 
     * @param {GervaisAnimatedSpritesheet} spellFxSpritesheet
     */
    constructor(laserArray, spellFxSpritesheet) {
        super();

        /**
         * @constant
         * @type {Laser[]}
         */
        this.laserArray = laserArray;

        /**
         * @constant
         * @type {GervaisAnimatedSpritesheet}
         */
        this.spellFxSpritesheet = spellFxSpritesheet;

        /**
         * The sprite animation used for the Laser skill.
         * @private
         * @type {SpriteAnimation}
         */
        this.skillAnimation = null;
        /**
         * @type {number}
         */
        this.skillStart = Date.now();

        // /**
        //  * @constant
        //  * @type {Vector}
        //  */
        // this.screenCoordinate2 = new Vector(0, 0);

    }

    /**
     * @override
     * @param {CanvasRenderingContext2D} context 
     * @param {Projection} projection 
     */
    renderSkill(context, projection) {
        if (this.laserArray.length === 0) {
            return;
        }

        for (let i = 0; i < this.laserArray.length; i++) {
            this.renderLaser(context, projection, this.laserArray[i]);
        }
    }


    /**
     * @private
     * @param {CanvasRenderingContext2D} context 
     * @param {Projection} projection 
     * @param {Laser} laser 
     */
    renderLaser(context, projection, laser) {
        if (!laser.laserVisible) {
            return;
        }


        const now = Date.now();
        if (now - this.skillStart > 100000) {
            this.skillStart = now; // bad things happen in the sprite animation manager if the start time is from 1970.
        }

        // Make sure the sprite is initialized.
        if (!this.skillAnimation) {
            this.skillAnimation = this.spellFxSpritesheet.getSpriteAnimation(GervaisSpriteNames.EFFECT_NAME_SPARKLE_RED);
        }

        const startPoint = laser.startPoint;
        const endPoint = laser.endPoint;

        // Save the line width.
        const safeLineWidth = context.lineWidth;

        context.lineWidth = 5;
        context.strokeStyle = '#F00'; // maybe iterate through different colors per frame?

        context.beginPath();

        projection.worldToScreen(startPoint, this.screenCoordinate);
        context.moveTo(this.screenCoordinate.x, this.screenCoordinate.y);

        projection.worldToScreen(endPoint, this.screenCoordinate);
        context.lineTo(this.screenCoordinate.x, this.screenCoordinate.y);

        context.stroke();

        //////////////////////////////////////////

        context.lineWidth = 1;
        context.strokeStyle = '#FFF'; // maybe iterate through different colors per frame?

        context.beginPath();

        projection.worldToScreen(startPoint, this.screenCoordinate);
        context.moveTo(this.screenCoordinate.x, this.screenCoordinate.y);

        projection.worldToScreen(endPoint, this.screenCoordinate);
        context.lineTo(this.screenCoordinate.x, this.screenCoordinate.y);

        context.stroke();

        // Restore the line width
        context.lineWidth = safeLineWidth;

        if (projection.isVisible(endPoint, Settings.tile.size)) {

            this.screenCoordinate.copy(endPoint);

            // Center effect sprite on laser end point. (otherwise the top right corner is on the spot)
            this.screenCoordinate.x -= Settings.tile.halfSize;
            this.screenCoordinate.y -= Settings.tile.halfSize;

            projection.worldToScreen(this.screenCoordinate, this.screenCoordinate);

            const sprite = this.skillAnimation.getSpriteAsOf(Date.now(), this.skillStart);

            this.renderSprite(context, projection, sprite, this.screenCoordinate);
        }

        ///////////////////////////////////////////////////////////
        // DEBUG
        ///////////////////////////////////////////////////////////

        // context.lineWidth = 2;
        // context.strokeStyle = '#0FF'; // maybe iterate through different colors per frame?

        // context.beginPath();

        // projection.worldToScreen(startPoint, this.screenCoordinate);
        // context.moveTo(this.screenCoordinate.x, this.screenCoordinate.y);

        // projection.worldToScreen(laser.debugTargetPosition, this.screenCoordinate);
        // context.lineTo(this.screenCoordinate.x, this.screenCoordinate.y);

        // context.stroke();

        // ////////////////

        // this.screenCoordinate.copy(laser.debugTargetPosition);
        // this.screenCoordinate.addXY(4, 4);

        // this.screenCoordinate2.copy(laser.debugTargetPosition);
        // this.screenCoordinate2.addXY(Settings.tile.size - 4, Settings.tile.size - 4);

        // projection.worldToScreen(this.screenCoordinate, this.screenCoordinate);
        // projection.worldToScreen(this.screenCoordinate2, this.screenCoordinate2);

        // context.fillStyle = '#00FFFF';
        // context.fillRect(this.screenCoordinate.x, this.screenCoordinate.y, this.screenCoordinate2.x - this.screenCoordinate.x, this.screenCoordinate2.y - this.screenCoordinate.y);

    }
}